import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/widgets";
import { daysLabel } from "@/lib/helpers";
import { Skeleton } from "@/components/ui/skeleton";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { ShieldCheck, Calendar, Tag, CheckCircle2, AlertCircle } from "lucide-react";

export default function Insurance() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/insurance").then((r) => setData(r.data)).catch(() => {}); }, []);

  if (!data) return <Skeleton className="h-64 w-full rounded-3xl" />;
  const active = data.status === "active";

  return (
    <div className="space-y-6" data-testid="insurance-page">
      <PageHeader title="Insurance" subtitle="Stay covered on the road." icon={ShieldCheck} />

      <div className={`rounded-3xl border p-6 ${active ? "border-emerald-200 bg-emerald-50" : "border-red-200 bg-red-50"}`}>
        <div className="flex items-center gap-2">
          {active ? <CheckCircle2 className="text-emerald-600" size={22} /> : <AlertCircle className="text-red-600" size={22} />}
          <span className={`font-display text-lg font-bold ${active ? "text-emerald-700" : "text-red-700"}`}>
            {active ? "Active" : "Action needed"}
          </span>
        </div>
        {data.policy ? (
          <div className="mt-4 space-y-2 text-sm">
            <div className="flex items-center gap-2 text-zinc-700"><Calendar size={16} /> Expires: {data.policy.expiry_date}</div>
            <div className={`font-medium ${data.days_left < 14 ? "text-red-600" : "text-emerald-700"}`}>{daysLabel(data.days_left)}</div>
            {data.policy.number && <div className="text-zinc-500">Policy: {data.policy.number}</div>}
          </div>
        ) : (
          <p className="mt-3 text-sm text-zinc-600">No insurance on file. Add it in Car Care → Documents.</p>
        )}
        <Button data-testid="insurance-renew" onClick={() => toast.info("Connecting to insurance partner… (demo)")} className="mt-5 rounded-full bg-zinc-900 hover:bg-zinc-800">Renewal reminder</Button>
      </div>

      <div>
        <h3 className="mb-3 font-display font-semibold">Partner offers</h3>
        <div className="space-y-3">
          {data.offers.map((o, i) => (
            <div key={i} className="rounded-3xl border border-zinc-200 bg-white p-5" data-testid="insurance-offer">
              <div className="flex items-start justify-between">
                <div>
                  <div className="font-display font-semibold text-zinc-900">{o.provider}</div>
                  <div className="text-sm text-zinc-500">{o.product}</div>
                </div>
                <span className="rounded-full bg-emerald-50 px-2.5 py-0.5 text-xs font-semibold text-emerald-700">{o.price}</span>
              </div>
              <div className="mt-3 flex items-center justify-between">
                <span className="flex items-center gap-1.5 text-xs text-amber-600"><Tag size={13} /> {o.discount}</span>
                <Button size="sm" variant="outline" className="rounded-full" onClick={() => toast.info("Partner integration coming soon.")}>Get quote</Button>
              </div>
            </div>
          ))}
        </div>
        <p className="mt-4 text-xs text-zinc-400">VecPadi does not issue insurance directly. Offers are from licensed partners.</p>
      </div>
    </div>
  );
}
